import { Button, Modal, Select, TextInput } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useAppDispatch, useAppSelector } from '../../../Reducers/store';
import { ClientInventoryMarkUp } from '../../../Models/ClientInventoryMarkUp';
import ClientApi from '../../../Api/ClientApi';
import { fetchInventoryTypes } from '../../../Actions/CommonFields';
import { formatNumbers, onlyNumberInput } from '../../../Utils';

export default function ClientInventoryMarkUpModal({
  show,
  setShow,
  getClientInventoryMarkUps,
  clientId,
  selectedClientMarkup,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  clientId: number;
  getClientInventoryMarkUps: (clientId: number) => Promise<void> | undefined;
  selectedClientMarkup: ClientInventoryMarkUp | null;
}) {
  const dispatch = useAppDispatch();
  const { inventoryTypes } = useAppSelector((state) => state.commonFields);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

  const [formData, setFormData] = useState<ClientInventoryMarkUp>({
    id: 0,
    clientId: clientId,
    inventoryTypeId: null,
    markupPrice: null,

    inventoryType: null,
  });

  const getReferences = async () => {
    if (!inventoryTypes.length) {
      await Promise.all([dispatch(fetchInventoryTypes())]);
    }
  };

  useEffect(() => {
    if (show === true) {
      getReferences();
    }
  }, [show]);

  const handleSetInitialValues = () => {
    const values = selectedClientMarkup
      ? {
          ...selectedClientMarkup,
        }
      : {
          id: 0,
          clientId: clientId,
          inventoryTypeId: null,
          markupPrice: null,

          inventoryType: null,
        };
    setFormData(values as ClientInventoryMarkUp);
  };

  useEffect(() => {
    handleSetInitialValues();
  }, [selectedClientMarkup]);

  const handleResetFormValues = () => {
    const values = {
      id: 0,
      clientId: clientId,
      inventoryTypeId: null,
      markupPrice: null,

      inventoryType: null,
    };
    setFormData(values as ClientInventoryMarkUp);
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleChangeCurrencyInput = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = e.target;
    const formattedValue = formatNumbers(value);
    setFormData((prevData) => ({ ...prevData, [name]: formattedValue }));
  };

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setButtonDisabled(true);
    setIsLoading(true);
    return await ClientApi.addUpdateClientInventoryMarkUp(formData)
      .then((res) => {
        if (res.data.success) {
          toast.success('Save Success');
          setIsLoading(false);
          setButtonDisabled(false);
          getClientInventoryMarkUps(clientId);
          onCloseModal();
        } else {
          toast.error(res.data.message);
          setIsLoading(false);
          setButtonDisabled(false);
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error('Error: ' + err);
        setIsLoading(false);
        setButtonDisabled(false);
      });
  };

  function onCloseModal() {
    handleResetFormValues();
    setButtonDisabled(false);
    setShow(false);
  }

  return (
    <Modal show={show} size='2xl' onClose={onCloseModal} popup>
      <Modal.Header></Modal.Header>
      <Modal.Body>
        <div className='w-full'>
          <div className='w-full'>
            <div className='mx-1 flex items-end justify-center'>
              <div className='flex flex-1 justify-center'>
                <h1 className='text-gray-900 font-bold text-4xl'>
                  {selectedClientMarkup ? 'Edit' : 'Add'} Mark up
                </h1>
              </div>
            </div>
          </div>

          <div>
            <div className='container mx-auto p-2'>
              <div className='md:flex no-wrap md:-mx-2 '>
                <div className='w-full'>
                  <div className='bg-white'>
                    <hr className='bg-gray-300 h-[5px]'></hr>
                    <form id='clientMarkupForm' onSubmit={onSubmit}>
                      <div className='text-gray-500'>
                        <div className='grid grid-cols-[35%_65%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Type:
                            </div>
                          </div>
                          <div className='w-full'>
                            <Select
                              id='inventoryTypeId'
                              name='inventoryTypeId'
                              onChange={handleChangeSelect}
                              value={formData.inventoryTypeId ?? ''}
                              sizing='md'
                              required
                            >
                              <option value={''}>(Select)</option>
                              {inventoryTypes.map((type) => (
                                <option key={type.id} value={type.id}>
                                  {type.name}
                                </option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <hr className='bg-gray-300 h-[2px]'></hr>
                        <div className='grid grid-cols-[35%_65%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Mark Up:
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='markupPrice'
                              name='markupPrice'
                              type='text'
                              placeholder='0.00'
                              onChange={handleChangeCurrencyInput}
                              onKeyDown={(event) => {
                                if (onlyNumberInput(event)) {
                                  event.preventDefault();
                                }
                              }}
                              value={formData.markupPrice ?? ''}
                              sizing='md'
                              addon='$'
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className='flex justify-end pt-2'>
                        <Button
                          form='clientMarkupForm'
                          disabled={buttonDisabled}
                          type='submit'
                          className='buttonMain'
                        >
                          Save
                        </Button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
